export enum MappingType {
  EVENTS = `events`,
  PROPERTIES = `properties`,
}

export type BoardEventsInfo = {
  [MappingType.EVENTS]: string[];
  [MappingType.PROPERTIES]: string[];
};

type BoardEventsMapping = {
  [MappingType.EVENTS]: {
    [key: string]: string;
  };
  [MappingType.PROPERTIES]: {
    [key: string]: string;
  };
};

export interface CopyBoardModalState {
  boardEventsMapping: BoardEventsMapping;
}

export interface CopyBoardModalAttrs {
  'board-events-info': BoardEventsInfo;
}
